import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const PlayIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.22435 2.45775C6.76193 1.37438 4.70577 2.32241 4.52257 4.16452L3.01276 19.3457C2.82758 21.2077 4.6928 22.5642 6.34187 21.7669L19.6549 15.3296C21.27 14.5487 21.4753 12.2741 20.0276 11.2017L8.22435 2.45775Z"
      fill={color}
    />
  </svg>
);
